export default __webpack_public_path__ + "static/media/about-first.090c9512.jpg";